import { render, staticRenderFns } from "./ProductCostCapture.vue?vue&type=template&id=c14b8b60&scoped=true"
import script from "./ProductCostCapture.vue?vue&type=script&lang=js"
export * from "./ProductCostCapture.vue?vue&type=script&lang=js"
import "./ProductCostCapture.vue?vue&type=style&index=0&id=c14b8b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14b8b60",
  null
  
)

export default component.exports